export default {"src":"/_next/static/media/ya-market.d0c03b04.svg","height":15,"width":102,"blurWidth":0,"blurHeight":0};